import Immutable from 'immutable';

import * as actions from './actions';

const defaultState = Immutable.Map();

export default (state = defaultState, action) => {
  switch (action.type) {
    case actions.SET_KEYSTORE_ITEM_REQUEST:
      return state.setIn(
        ['keystore', action.payload.key],
        action.payload.value
      );

    case actions.SET_KEYSTORE_ITEM_FAILURE: {
      if (typeof action.payload.originalValue === 'undefined') {
        // if they didn't have the key set previously lets remove it.
        return state.removeIn(['keystore', action.payload.key]);
      }
      // otherwise restore it to what it was.
      return state.setIn(
        ['keystore', action.payload.key],
        action.payload.originalValue
      );
    }

    default:
      return state;
  }
};
